import { useState, useEffect } from "react";
import styled from "styled-components";
import EmailTextArea from "./EmailTextArea";
import { ReactComponent as Elipsis } from "../../../assets/img/icons/ArticlePopover/Elipsis.svg";
import CalendarDiv from "modules/Common/CalendarDiv";
import ImageCollectionItem from "modules/Common/Components/ImageCollectionItem";
import ShareMenuPopup from "../../Common/Components/ShareMenuPopup";
import { Link } from "react-router-dom";
import Input from "../../Common/Components/Input";
import { getQueryParam } from "utils";
import TickNormal from "../../../assets/img/icons/tickNormal.svg";
import crossNormal from "../../../assets/img/icons/crossNormal.svg";
import { getQueryAssetId, getQueryCampaignId } from "modules/EmailBrowser/utils";
import { useLocation } from "react-router";
import { ASSET_TYPE } from "../../../constants/index";
import DraftMenuPopup from "modules/Common/Components/DraftMenuPopup";
import {
  deleteNewlyCreatedDraft,
  deleteNewlyCreatedDraftAssetWithoutCampaign,
} from "modules/EmailBrowser/actions";
import { DESIGN } from "constants/actionTypes";
import store from "store";

interface EmailCardProps {
  id?: any;
  draftName: string;
  draftTitle: string;
  curatedArticlesCount: string;
  wide: boolean;
  calendar: boolean;
  date: any;
  img: String;
  month: String;
  description?: String;
  title?: String;
  link?: String;
  campaignId?: number;
  onCardClick?: () => void;
  assetType?: String;
  assetId?: any;
}

export default function EmailCard(props: EmailCardProps) {
  const { id, draftTitle, draftName, campaignId, assetId } = props;
  const [name, setName] = useState(props.draftName);
  const [subject, setSubject] = useState(props.draftName);

  const version_id = id;
  const location = useLocation();

  const [editMode, setEditMode] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [toggleEditMode, setToggleEditMode]: [any, any] = useState(false);
  let asset_id: any;
  const history = useHistory();
  const setItemNameHandler = () => {
    if (version_id) {
      asset_id = version_id;
    } else {
      asset_id = getQueryParam("asset_id");
    }
    let asset_name: any;
    if (inputValue !== undefined) {
      asset_name = inputValue;
    } else {
      asset_name = draftName;
    }
  };

  const resetItemNameHandler = () => {
    setEditMode(false);
    setInputValue(draftTitle);
  };

  const handleSave = () => {
    if (draftTitle !== inputValue) {
      if (inputValue?.trim() !== "") setItemNameHandler();
    } else {
      // setToggleEditMode("editable-active");
      setEditMode(false);
      resetItemNameHandler();
    }
  };

  const handleInputKeyUp = (e: any) => {
    if (e.key === "Enter") {
      if (draftTitle !== inputValue) {
        if (inputValue?.trim() !== "") setItemNameHandler();
      } else {
        setEditMode(false);
        setToggleEditMode("editable-active");
        resetItemNameHandler();
      }
    }
  };

  const getURL = () => {
    const search = location.search;
    const url = `/campaigns/editionedit${search.length > 0 ? search + "&" : "?"}email_id=${props.id}`;
    return url;
  };
  function onCardClick() {
    store.dispatch({
      type: DESIGN.RESET,
    });
    if (props.assetType === ASSET_TYPE.CUSTOM) {
      history.push(
        `/campaigns/editionedit/design/?campaign_id=${getQueryCampaignId()}&asset_id=${getQueryAssetId()}&version_id=${id}`
      );
    } else history.push(getURL());
  }
  useEffect(() => {}, [draftTitle]);
  getURL();

  useEffect(() => {
    setSubject(props.draftName);
    setInputValue(props.draftName);
  }, [props.draftName]);

  return (
    <EmailCardWrapper wide={props.wide} {...(props.onCardClick ? { onClick: props.onCardClick } : {})}>
      <div className="d-flex flex-row">
        {props.calendar === true ? (
          <div className="calendar-div">
            <CalendarDiv color="Red" date={props.date} month={props.month} />
          </div>
        ) : null}

        <ImageCollectionItem img={props.img} assetType={props.assetType !== undefined ? props.assetType : ""} />
      </div>
      <EmailTextIconsContainer>
        <Link to="" onClick={onCardClick} style={{ width: "100%" }}>
          <EmailTextArea
            id={props.id}
            draftName={"Edition Name: "}
            draftTitle={subject}
            curatedArticlesCount={props.curatedArticlesCount}
            editable={true}
            assetType={props.assetType}
          />
        </Link>
        <IconsContainer>
          <div className="oval-text">
            <span className="text draft-text">Draft</span>
          </div>
          <div className="ellipses clickable">
            <DraftMenuPopup
              id={props.id}
              data={props}
              versionId={id}
              assetId={assetId}
              campaignId={campaignId}
              deleteHandler={(value: any) => {
                // console.log("Draft delete Draft");
                if (campaignId) deleteNewlyCreatedDraft(asset_id, version_id);
                else deleteNewlyCreatedDraftAssetWithoutCampaign(asset_id, version_id);
              }}
              assetType={props.assetType}
            >
              <Elipsis />
            </DraftMenuPopup>
          </div>
        </IconsContainer>
      </EmailTextIconsContainer>
    </EmailCardWrapper>
  );
}

const EmailTextIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin-left: 18px;
  width: 100%;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    margin-left: 10px;
  }
`;
const IconsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: auto;
  .oval-text {
    background: #f6dede;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px 8px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 11px;
      padding: 2px 5px;
    }
    .draft-text {
      font-weight: bold;
    }
    .text {
      color: #c21e1e;
      font-size: 12px;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 9px;
      }
    }
  }
  .ellipses {
    display: flex;
    justify-content: flex-end;
    padding-right: 7px;
    margin-top: 100%;
    svg {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 3px;
      }
    }
  }
`;
const OvalText = styled.div`
  background: #27ce0a;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25%;
  margin-right: 21px;
  margin-left: 23px;
`;
const EmailCardWrapper = styled.div<{ wide: boolean }>`
  display: flex;
  flex-direction: row;
  box-shadow: 0px 0px 17px -8px rgba(0, 0, 0, 0.25);
  background-color: #fff;
  border-radius: 10px;
  max-width: ${(props) => (props.wide ? "100%" : "875px")};
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    border-radius: 7px;
  }
  .clickable {
    cursor: pointer;
  }
  .calendar-div {
    display: flex;
    align-items: center;
    margin-left: 1.75em;
    margin-right: 1.5em;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin-left: 18px;
      margin-right: 18px;
    }
  }
`;

const InputWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  margin-left: 10px;

  label {
    display: none;
  }
  input {
    padding-right: 70px;
    width: 500px;
  }
  .save {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    img {
      vertical-align: middle;
      max-width: 20px;
    }
  }
  .cancel {
    position: absolute;
    top: 10px;
    right: 40px;
    cursor: pointer;
    img {
      vertical-align: middle;
      max-width: 20px;
      padding: 2px;
    }
  }
`;
function updateEditionSubject(arg0: any, subjectRef: any) {
  throw new Error("Function not implemented.");
}

function getVersionId(): any {
  throw new Error("Function not implemented.");
}

function subjectRef(arg0: any, subjectRef: any) {
  throw new Error("Function not implemented.");
}
